import store from "@/config/vuex/store";

export default [
    {
        path: "/grupo-empresas",
        component: () => import('@/pages/Layout/DashboardLayout'),
        children: [
            {
                path: "/",
                name: "grupo_empresasRead",
                component: () => import('@/pages/GrupoEmpresa/GrupoEmpresaRead'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "cadastrar",
                name: "grupo_empresasCreate",
                component: () => import('@/pages/GrupoEmpresa/GrupoEmpresaCreate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }, 
            {
                path: "editar/:id",
                name: "grupo_empresasUpdate",
                component: () => import('@/pages/GrupoEmpresa/GrupoEmpresaUpdate'),
                beforeEnter: (to, from, next) => {
                    if (store.state.permissoes) {                        
                        store.state.permissoes.includes(to.name) ? next() : next(false)
                    }
                }
            }
        ]
    }
]

